import React, { useState, useEffect } from "react";
import { Spin, Modal, message, Dropdown,} from "antd";
import {
  TeamOutlined, PlusOutlined, FilterOutlined,
  MoreOutlined, EyeOutlined, EditOutlined, DeleteOutlined,
  MailOutlined, PhoneOutlined, NumberOutlined,
} from "@ant-design/icons";
import api from "../services/api";

// ── Extrai mensagem de erro do response ────────────────────────────────
const getErroMsg = (e, fallback = "Erro desconhecido.") => {
  const d = e?.response?.data;
  if (!d) return e?.message || fallback;
  if (typeof d === "string") return d;
  if (typeof d === "object") return d.description || d.error || d.message || fallback;
  return fallback;
};

// ── Helper FireDAC ──────────────────────────────────────────────────────
const extractRows = (data) => {
  if (!data) return [];
  if (data.FDBS) {
    try {
      const tables = data.FDBS.Manager.TableList;
      if (tables?.length > 0 && tables[0].RowList)
        return tables[0].RowList.map((r) => r.Original);
    } catch (e) {}
  }
  if (data.Table && Array.isArray(data.Table)) return data.Table;
  if (Array.isArray(data)) return data;
  return [];
};

// ── Logos programas com cores exatas e quantidades ─────────────────────
const LOGOS_MAP_PROG = [
  // ── Nacionais ──────────────────────────────────────────────────────
  { keys: ["livelo"],                    bg: "#e8008b", label: "LV", qtd: 1 },
  { keys: ["itaú pontos","itau pontos"], bg: "#d48c0c", label: "IT", qtd: 1 },
  { keys: ["smiles"],                    bg: "#ff6600", label: "S", qtd: 1 },
  { keys: ["azul"],                      bg: "#003087", label: "A", qtd: 1 },
  { keys: ["coopera pj"],                bg: "#007b5e", label: "CPJ", qtd: 1 },
  { keys: ["coopera"],                   bg: "#007b5e", label: "COO", qtd: 1 },
  { keys: ["latam"],                     bg: "#d81a36", label: "L", qtd: 1 },
  { keys: ["tap"],                       bg: "#009900", label: "TAP", qtd: 1 },
  { keys: ["max milhas"],                bg: "#1e3a6e", label: "MM", qtd: 1 },
  { keys: ["hotmilhas"],                 bg: "#cc3300", label: "HM", qtd: 1 },
  { keys: ["ipiranga"],                  bg: "#f5a800", label: "IP", qtd: 1 },
  { keys: ["esfera empresas"],           bg: "#8b0000", label: "EE", qtd: 1 },
  { keys: ["esfera"],                    bg: "#8b0000", label: "E_", qtd: 1 },
  { keys: ["bank milhas"],               bg: "#0066cc", label: "BM", qtd: 1 },
  { keys: ["cash milhas"],               bg: "#5a5a5a", label: "CM", qtd: 1 },
  { keys: ["curtaí","curtai"],           bg: "#e8a000", label: "CT", qtd: 1 },
  { keys: ["compro suas milhas"],        bg: "#1e3a4a", label: "CSM", qtd: 1 },
  { keys: ["átomos","atomos"],           bg: "#000000", label: "ÁT", qtd: 1 },
  { keys: ["gpa"],                       bg: "#00aa44", label: "GPA", qtd: 1 },
  { keys: ["pontos caixa"],              bg: "#007b5e", label: "PC", qtd: 1 },
  { keys: ["caixa empresas"],            bg: "#007b5e", label: "CE", qtd: 1 },
  { keys: ["sicredi empresarial"],       bg: "#009900", label: "SCE", qtd: 1 },
  { keys: ["sicredi"],                   bg: "#009900", label: "SC", qtd: 1 },
  { keys: ["dotz"],                      bg: "#ff6600", label: "DZ", qtd: 1 },
  { keys: ["porto plus"],                bg: "#0057a8", label: "PP", qtd: 1 },
  { keys: ["inter loop"],                bg: "#ff6b00", label: "IL", qtd: 1 },
  { keys: ["inter empresas"],            bg: "#ff6b00", label: "IE", qtd: 1 },
  { keys: ["volare"],                    bg: "#c8102e", label: "VL", qtd: 1 },
  { keys: ["membership","amex"],         bg: "#006fcf", label: "MR", qtd: 1 },
  { keys: ["safra"],                     bg: "#003366", label: "SR", qtd: 1 },
  { keys: ["suma"],                      bg: "#1e3a4a", label: "SU", qtd: 1 },
  { keys: ["cressol"],                   bg: "#007b5e", label: "CR", qtd: 1 },
  { keys: ["banrisul"],                  bg: "#003087", label: "BR", qtd: 1 },
  { keys: ["unicred"],                   bg: "#009900", label: "UC", qtd: 1 },
  { keys: ["milhas plus"],               bg: "#e8a000", label: "M+", qtd: 1 },
  { keys: ["xp pontos"],                 bg: "#1a1a2e", label: "XP", qtd: 1 },
  { keys: ["nubank"],                    bg: "#820ad1", label: "NU", qtd: 1 },
  { keys: ["ailos"],                     bg: "#007b5e", label: "AI", qtd: 1 },
  { keys: ["banestes"],                  bg: "#003087", label: "BN", qtd: 1 },
  { keys: ["bb empresas"],               bg: "#f5a800", label: "BB", qtd: 1 },
  { keys: ["itaú empresas","itau empresas"], bg: "#d48c0c", label: "ITE", qtd: 1 },
  { keys: ["pontos btg"],                bg: "#1a1a2e", label: "BTG", qtd: 1 },
  
  // ── Internacionais ──────────────────────────────────────────────────
  { keys: ["iberia"],                    bg: "#cc0000", label: "IB", qtd: 1 },
  { keys: ["mileageplus","united"],      bg: "#002244", label: "UA", qtd: 1 },
  { keys: ["all accor","accor"],         bg: "#c8102e", label: "AL", qtd: 1 },
  { keys: ["ihg"],                       bg: "#6a0dad", label: "IHG", qtd: 1 },
  { keys: ["aadvantage","american"],     bg: "#0078d2", label: "AA", qtd: 1 },
  { keys: ["flying blue"],               bg: "#003087", label: "FB", qtd: 1 },
  { keys: ["british"],                   bg: "#2b4090", label: "BA", qtd: 1 },
  { keys: ["qatar"],                     bg: "#5c0632", label: "QR", qtd: 1 },
  { keys: ["aeroplan"],                  bg: "#c8102e", label: "AP", qtd: 1 },
  { keys: ["copa","connectmiles"],       bg: "#0033a0", label: "CM", qtd: 1 },
  { keys: ["delta"],                     bg: "#c8102e", label: "DL", qtd: 1 },
  { keys: ["emirates"],                  bg: "#c8102e", label: "EK", qtd: 1 },
  { keys: ["virgin","flying club"],      bg: "#e8003d", label: "VS", qtd: 1 },
  { keys: ["finnair"],                   bg: "#003580", label: "AY", qtd: 1 },
  { keys: ["wyndham"],                   bg: "#003087", label: "WY", qtd: 1 },
];

// ── Lista completa com cores exatas e quantidade ───────────────────────────
const PROGRAMAS_LISTA = [
  // ── Nacionais ──────────────────────────────────────────────────────
  { nome: "Livelo",                        bg: "#e8008b", letra: "LV", qtd: 1 },
  { nome: "Itaú Pontos",                   bg: "#d48c0c", letra: "IT", qtd: 1 },
  { nome: "Smiles",                        bg: "#ff6600", letra: "S", qtd: 1 },
  { nome: "Azul Fidelidade",               bg: "#003087", letra: "A", qtd: 1 },
  { nome: "Coopera",                       bg: "#007b5e", letra: "COO", qtd: 1 },
  { nome: "Latam Pass",                    bg: "#d81a36", letra: "L", qtd: 1 },
  { nome: "Max Milhas",                    bg: "#1e3a6e", letra: "MM", qtd: 1 },
  { nome: "HotMilhas",                     bg: "#cc3300", letra: "HM", qtd: 1 },
  { nome: "Ipiranga",                      bg: "#f5a800", letra: "IP", qtd: 1 },
  { nome: "Esfera",                        bg: "#8b0000", letra: "E_", qtd: 1 },
  { nome: "Bank Milhas",                   bg: "#0066cc", letra: "BM", qtd: 1 },
  { nome: "Cash Milhas",                   bg: "#5a5a5a", letra: "CM", qtd: 1 },
  { nome: "Curtaí",                        bg: "#e8a000", letra: "CT", qtd: 1 },
  { nome: "Compro Suas Milhas",            bg: "#1e3a4a", letra: "CSM", qtd: 1 },
  { nome: "Átomos",                        bg: "#000000", letra: "ÁT", qtd: 1 },
  { nome: "GPA",                           bg: "#00aa44", letra: "GPA", qtd: 1 },
  { nome: "Pontos Caixa",                  bg: "#007b5e", letra: "PC", qtd: 1 },
  { nome: "Sicredi",                       bg: "#009900", letra: "SC", qtd: 1 },
  { nome: "Dotz",                          bg: "#ff6600", letra: "DZ", qtd: 1 },
  { nome: "Porto Plus",                    bg: "#0057a8", letra: "PP", qtd: 1 },
  { nome: "Inter Loop",                    bg: "#ff6b00", letra: "IL", qtd: 1 },
  { nome: "Volare",                        bg: "#c8102e", letra: "VL", qtd: 1 },
  { nome: "Membership Rewards Amex",       bg: "#006fcf", letra: "MR", qtd: 1 },
  { nome: "Safra Rewards",                 bg: "#003366", letra: "SR", qtd: 1 },
  { nome: "SUMA",                          bg: "#1e3a4a", letra: "SU", qtd: 1 },
  { nome: "Cressol",                       bg: "#007b5e", letra: "CR", qtd: 1 },
  { nome: "Banrisul",                      bg: "#003087", letra: "BR", qtd: 1 },
  { nome: "Unicred",                       bg: "#009900", letra: "UC", qtd: 1 },
  { nome: "Milhas Plus",                   bg: "#e8a000", letra: "M+", qtd: 1 },
  { nome: "XP Pontos",                     bg: "#1a1a2e", letra: "XP", qtd: 1 },
  { nome: "Nubank Rewards",                bg: "#820ad1", letra: "NU", qtd: 1 },
  { nome: "AILOS",                         bg: "#007b5e", letra: "AI", qtd: 1 },
  { nome: "Banestes Fidelidade",           bg: "#003087", letra: "BN", qtd: 1 },
  
  // ── Empresarial ────────────────────────────────────────────────────
  { nome: "BB Empresas",                   bg: "#f5a800", letra: "BB", qtd: 1 },
  { nome: "Esfera Empresas",               bg: "#8b0000", letra: "EE", qtd: 1 },
  { nome: "Itaú Empresas",                 bg: "#d48c0c", letra: "ITE", qtd: 1 },
  { nome: "Inter Empresas",                bg: "#ff6b00", letra: "IE", qtd: 1 },
  { nome: "Caixa Empresas",                bg: "#007b5e", letra: "CE", qtd: 1 },
  { nome: "Pontos BTG",                    bg: "#1a1a2e", letra: "BTG", qtd: 1 },
  { nome: "Sicredi Empresarial",           bg: "#009900", letra: "SCE", qtd: 1 },
  { nome: "Coopera PJ",                    bg: "#007b5e", letra: "CPJ", qtd: 1 },
  
  // ── Internacionais ──────────────────────────────────────────────────
  { nome: "TAP Miles & Go",                bg: "#009900", letra: "TAP", qtd: 1 },
  { nome: "Iberia Plus",                   bg: "#cc0000", letra: "IB", qtd: 1 },
  { nome: "MileagePlus United",            bg: "#002244", letra: "UA", qtd: 1 },
  { nome: "All Accor",                     bg: "#c8102e", letra: "AL", qtd: 1 },
  { nome: "Qantas",                        bg: "#b22e2e", letra: "QT", qtd: 1 },
  { nome: "IHG Rewards",                   bg: "#6a0dad", letra: "IHG", qtd: 1 },
  { nome: "AAdvantage",                    bg: "#0078d2", letra: "AA", qtd: 1 },
  { nome: "Flying Blue",                   bg: "#003087", letra: "FB", qtd: 1 },
  { nome: "British Airways Executive Club",bg: "#2b4090", letra: "BA", qtd: 1 },
  { nome: "Qatar Airways Privilege Club",  bg: "#5c0632", letra: "QR", qtd: 1 },
  { nome: "Aeroplan",                      bg: "#c8102e", letra: "AP", qtd: 1 },
  { nome: "Copa ConnectMiles",             bg: "#0033a0", letra: "CM", qtd: 1 },
  { nome: "Delta SkyMiles",                bg: "#c8102e", letra: "DL", qtd: 1 },
  { nome: "Emirates Skywards",             bg: "#c8102e", letra: "EK", qtd: 1 },
  { nome: "Flying Club Virgin Atlantic",   bg: "#e8003d", letra: "VS", qtd: 1 },
  { nome: "Finnair Plus",                  bg: "#003580", letra: "AY", qtd: 1 },
  { nome: "Wyndham Rewards",               bg: "#003087", letra: "WY", qtd: 1 },

];

const getLogo = (nome = "") => {
  const n = nome.toLowerCase();
  for (const l of LOGOS_MAP_PROG) {
    if (l.keys.some((k) => n.includes(k))) return l;
  }
  return { bg: "#607d8b", label: (nome || "??").slice(0, 2).toUpperCase(), qtd: 0 };
};

const LogoProgramaCircle = ({ prog, size = 36 }) => (
  <span style={{
    display: "inline-flex", alignItems: "center", justifyContent: "center",
    width: size, height: size, borderRadius: "50%",
    background: prog.bg, color: "#fff",
    fontSize: size * 0.3, fontWeight: 700, flexShrink: 0,
    boxShadow: "0 1px 3px rgba(0,0,0,0.2)",
  }}>{prog.letra}</span>
);

const ProgramaBolinha = ({ nome, size = 40 }) => {
  const { bg, label } = getLogo(nome);
  return (
    <span title={nome} style={{
      display: "inline-flex", alignItems: "center", justifyContent: "center",
      width: size, height: size, borderRadius: "50%",
      background: bg, color: "#fff", fontSize: size * 0.28,
      fontWeight: 700, flexShrink: 0,
      boxShadow: "0 1px 3px rgba(0,0,0,0.18)",
    }}>{label}</span>
  );
};

// ── Máscaras ────────────────────────────────────────────────────────────
const mascaraCPF = (v = "") => {
  const d = v.replace(/\D/g, "").slice(0, 11);
  if (d.length <= 3) return d;
  if (d.length <= 6) return `${d.slice(0,3)}.${d.slice(3)}`;
  if (d.length <= 9) return `${d.slice(0,3)}.${d.slice(3,6)}.${d.slice(6)}`;
  return `${d.slice(0,3)}.${d.slice(3,6)}.${d.slice(6,9)}-${d.slice(9)}`;
};
const mascaraTelefone = (v = "") => {
  const d = v.replace(/\D/g, "").slice(0, 11);
  if (d.length <= 2)  return `(${d}`;
  if (d.length <= 7)  return `(${d.slice(0,2)}) ${d.slice(2)}`;
  return `(${d.slice(0,2)}) ${d.slice(2,7)}-${d.slice(7)}`;
};

// ── Componentes de campo ────────────────────────────────────────────────
const FieldInput = ({ label, value, onChange, placeholder, suffix, readOnly, half }) => (
  <div style={{ flex: half ? "0 0 calc(50% - 6px)" : "1 1 100%", minWidth: 0 }}>
    {label && <div style={{ fontSize: 11, color: "#888", marginBottom: 3 }}>{label}</div>}
    <div style={{
      display: "flex", alignItems: "center",
      background: readOnly ? "#f4f6f9" : "#fff",
      borderRadius: 6, border: "1px solid #dde1e9",
      padding: "0 10px", minHeight: 34,
    }}>
      <input
        readOnly={readOnly}
        value={value ?? ""}
        onChange={onChange ? (e) => onChange(e.target.value) : undefined}
        placeholder={placeholder || ""}
        style={{
          flex: 1, border: "none", background: "transparent",
          outline: "none", fontSize: 13, color: readOnly ? "#333" : "#222",
          padding: "6px 0",
        }}
      />
      {suffix && <span style={{ color: "#bbb", marginLeft: 6, fontSize: 13 }}>{suffix}</span>}
    </div>
  </div>
);

const ModalLayout = ({ title, children, onCancel, onConfirm, confirmLabel, saving }) => (
  <div style={{ padding: "4px 0" }}>
    <div style={{ fontSize: 13, fontWeight: 600, color: "#333", marginBottom: 12 }}>{title}</div>
    <div style={{ background: "#f7f9fc", borderRadius: 8, border: "1px solid #e4e8ef", padding: "14px 14px", display: "flex", flexDirection: "column", gap: 8 }}>
      {children}
    </div>
    <div style={{ display: "flex", justifyContent: "flex-end", gap: 8, marginTop: 14 }}>
      <button onClick={onCancel} style={{ padding: "6px 20px", borderRadius: 4, border: "1px solid #d9d9d9", background: "#fff", cursor: "pointer", fontSize: 12, fontWeight: 700, letterSpacing: "0.06em", color: "#555" }}>
        CANCELAR
      </button>
      <button onClick={onConfirm} disabled={saving} style={{ padding: "6px 20px", borderRadius: 4, border: "1px solid #d9d9d9", background: "#fff", cursor: saving ? "not-allowed" : "pointer", fontSize: 12, fontWeight: 700, letterSpacing: "0.06em", color: saving ? "#ccc" : "#888" }}>
        {confirmLabel}
      </button>
    </div>
  </div>
);

// ── Seção bancária ──────────────────────────────────────────────────────
const SecaoBancaria = ({ banco, agencia, conta, pix, onChange, readOnly }) => (
  <>
    <div style={{ fontSize: 11, color: "#888", marginBottom: -2 }}>Dados para transferência</div>
    <div style={{ display: "flex", gap: 8 }}>
      <FieldInput value={banco}   onChange={readOnly ? null : (v) => onChange("banco", v)}   placeholder="Banco"          readOnly={readOnly} />
      <FieldInput value={agencia} onChange={readOnly ? null : (v) => onChange("agencia", v)} placeholder="Agência"        readOnly={readOnly} />
      <FieldInput value={conta}   onChange={readOnly ? null : (v) => onChange("conta", v)}   placeholder="Conta Corrente" readOnly={readOnly} />
    </div>
    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
      <div style={{ flex: 1, display: "flex", alignItems: "center", background: readOnly ? "#f4f6f9" : "#fff", borderRadius: 6, border: "1px solid #dde1e9", padding: "0 10px", minHeight: 38 }}>
        <input
          readOnly={readOnly}
          value={pix ?? ""}
          onChange={readOnly ? undefined : (e) => onChange("pix", e.target.value)}
          placeholder="Chave PIX"
          style={{ flex: 1, border: "none", background: "transparent", outline: "none", fontSize: 13, color: "#333", padding: "8px 0" }}
        />
      </div>
      <MailOutlined   style={{ color: "#bbb", fontSize: 14 }} />
      <NumberOutlined style={{ color: "#bbb", fontSize: 14 }} />
      <PhoneOutlined  style={{ color: "#bbb", fontSize: 14 }} />
    </div>
  </>
);

// ── Comissão ────────────────────────────────────────────────────────────
const SecaoComissao = ({ valor, onChange, tipo, onTipo, readOnly }) => (
  <>
    <div style={{ borderTop: "1px solid #e0e4ea" }} />
    <FieldInput
      label="Comissão"
      value={valor}
      onChange={readOnly ? null : onChange}
      readOnly={readOnly}
      suffix={<span style={{ fontSize: 12 }}>%</span>}
    />
    <div style={{ display: "flex", gap: 20 }}>
      <label style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 13, color: "#444", cursor: "pointer" }}>
        <input type="radio" name="tipoComissao" checked={tipo === "percentual"} onChange={() => !readOnly && onTipo("percentual")} style={{ accentColor: "#1677ff" }} />
        Percentual
      </label>
      <label style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 13, color: "#444", cursor: "pointer" }}>
        <input type="radio" name="tipoComissao" checked={tipo === "fixo"} onChange={() => !readOnly && onTipo("fixo")} style={{ accentColor: "#1677ff" }} />
        Valor Fixo
      </label>
    </div>
    <div style={{ borderTop: "1px solid #e0e4ea" }} />
  </>
);

// ══════════════════════════════════════════════════════════════════════
export default function Titulares({ clienteId: clienteIdProp }) {
  const [loading, setLoading]           = useState(false);
  const [saving, setSaving]             = useState(false);
  const [clientes, setClientes]         = useState([]);
  const [cartoes, setCartoes]           = useState({});  // mapa cli_id -> [{car_id, car_nome_programa}]
  const [busca, setBusca]               = useState("");
  const [clienteId, setClienteId]       = useState(null);
  const [loginId, setLoginId]           = useState(null);

  // Modal Editar Titular
  const [modalEditar, setModalEditar]         = useState(false);
  const [titularEditando, setTitularEditando] = useState(null);
  const [editForm, setEditForm]               = useState({ nome: "", cpf: "", email: "", celular: "" });
  const [salvandoEdit, setSalvandoEdit]       = useState(false);

  // Modal Excluir Titular
  const [modalExcluir, setModalExcluir]       = useState(false);
  const [titularExcluindo, setTitularExcluindo] = useState(null);
  const [excluindo, setExcluindo]             = useState(false);

  // Modal Novo Titular
  const [modalNovo, setModalNovo]       = useState(false);
  const [novoTipo, setNovoTipo]         = useState("percentual");
  const [novoForm, setNovoForm]         = useState({
    nome: "", apelido: "", cpf: "", email: "", celular: "",
    comissao: "", banco: "", agencia: "", conta: "", pix: "",
  });

  // Modal Detalhe
  const [modalDetalhe, setModalDetalhe] = useState(false);
  const [titularSel, setTitularSel]     = useState(null);
  const [detTipo, setDetTipo]           = useState("percentual");

  // Modal Novo Programa (botão +)
  const [modalPrograma, setModalPrograma] = useState(false);
  const [titularPrograma, setTitularPrograma] = useState(null);
  const [savingProg, setSavingProg]       = useState(false);
  const [progBusca, setProgBusca]         = useState(null);
  const [progSel, setProgSel]             = useState(null);
  const [progEmail, setProgEmail]         = useState("");
  const [progNumero, setProgNumero]       = useState("");
  const [progNumeroPrograma, setProgNumeroPrograma] = useState("");

  // ── Resolve clienteId ──────────────────────────────────────────────
  useEffect(() => {
    let id = clienteIdProp;
    let logId = null;
    try {
      const u = JSON.parse(localStorage.getItem("user") || "{}");
      if (!id) id = u.cli_id || u.id;
      logId = u.log_id || u.id || id;
    } catch (e) {}
    if (!id) id = parseInt(localStorage.getItem("userID") || "0") || null;
    if (!logId) logId = id;
    if (id) { setClienteId(id); setLoginId(logId); carregarDados(id); }
  }, [clienteIdProp]);

  const carregarDados = async (id) => {
    setLoading(true);
    try {
      let titRows = [];

      try {
        const cliRes = await api.get("/ServerPrincipal/PesquisaTitular", { params: { Cliente: id } });
        titRows = extractRows(cliRes.data);
      } catch (e) {
        console.error("PesquisaTitular falhou:", e?.response?.status, e?.message);
      }

      const seenTit = new Set();
      const titularesDeduplic = titRows.filter((t) => {
        const rawId = t.cli_id ?? t.CLI_ID;
        const k = rawId != null ? String(rawId) : null;
        if (!k || k === "0" || seenTit.has(k)) return false;
        seenTit.add(k);
        return true;
      });

      const cartoesMap = {};
      titRows.forEach((t) => {
        const rawId  = t.cli_id ?? t.CLI_ID;
        const carId  = t.car_id ?? t.CAR_ID;
        const carNome = t.car_nome_programa ?? t.CAR_NOME_PROGRAMA;
        if (!rawId || !carId) return;
        const k = String(rawId);
        if (!cartoesMap[k]) cartoesMap[k] = [];
        if (!cartoesMap[k].find(c => String(c.car_id) === String(carId))) {
          cartoesMap[k].push({ 
            car_id: carId, 
            car_nome_programa: carNome, 
            cli_id: rawId,
            car_numero_programa: t.car_numero_programa ?? t.CAR_NUMERO_PROGRAMA ?? ""
          });
        }
      });

      setClientes(titularesDeduplic);
      setCartoes(cartoesMap);
    } catch (e) {
      console.error("Erro geral em carregarDados:", e);
      message.error("Erro ao carregar titulares.");
    } finally {
      setLoading(false);
    }
  };

  const programasPorCliente = (cliId) => {
    if (!cliId) return [];
    return cartoes[String(cliId)] || [];
  };

  const clientesFiltrados = clientes.filter((c) => {
    const q = busca.toLowerCase();
    const nome = (c.cli_nome || c.CLI_NOME || "").toLowerCase();
    const cpf  = (c.cli_cpf  || c.CLI_CPF  || c.tit_cpf || "").toLowerCase();
    return !q || nome.includes(q) || cpf.includes(q);
  });

  // ── Editar Titular ───────────────────────────────────────────────────
  const abrirEditar = (c) => {
    setTitularEditando(c);
    setEditForm({
      nome:    c.cli_nome     ?? c.CLI_NOME     ?? "",
      cpf:     mascaraCPF(c.cli_cpf ?? c.CLI_CPF ?? ""),
      email:   c.cli_email   ?? c.CLI_EMAIL   ?? "",
      celular: mascaraTelefone(c.cli_telefone ?? c.CLI_TELEFONE ?? ""),
    });
    setModalEditar(true);
  };

  const handleAtualizarTitular = async () => {
    if (!editForm.nome.trim()) { message.error("Nome é obrigatório."); return; }
    setSalvandoEdit(true);
    const cliId = titularEditando?.cli_id ?? titularEditando?.CLI_ID ?? 0;
    try {
      await api.post("/ServerPrincipal/AtualizarTitular", {
        Nome:     editForm.nome,
        CPF:      editForm.cpf.replace(/\D/g, ""),
        Email:    editForm.email || "",
        Telefone: editForm.celular.replace(/\D/g, "") || "",
        Cliente:  Number(cliId) || 0,
      });
      message.success("Titular atualizado com sucesso!");
      setModalEditar(false);
      carregarDados(clienteId);
    } catch (e) {
      message.error(getErroMsg(e, "Erro ao atualizar titular."));
    } finally {
      setSalvandoEdit(false);
    }
  };

  // ── Excluir Titular ───────────────────────────────────────────────────
  const abrirExcluir = (c) => {
    setTitularExcluindo(c);
    setModalExcluir(true);
  };

  const handleExcluirTitular = async () => {
    if (!titularExcluindo) return;
    setExcluindo(true);
    const cliId = titularExcluindo?.cli_id ?? titularExcluindo?.CLI_ID ?? 0;
    try {
      await api.post("/ServerPrincipal/DeletarTitular", {
        Cliente: Number(cliId) || 0,
      });
      message.success("Titular excluído com sucesso!");
      setModalExcluir(false);
      carregarDados(clienteId);
    } catch (e) {
      message.error(getErroMsg(e, "Erro ao excluir titular."));
    } finally {
      setExcluindo(false);
    }
  };

  const setEdit = (key, val) => setEditForm((p) => ({ ...p, [key]: val }));

  // ── Abrir detalhe ────────────────────────────────────────────────────
  const abrirDetalhe = (c) => {
    setTitularSel(c);
    setDetTipo("percentual");
    setModalDetalhe(true);
  };

  const abrirModalPrograma = (c) => {
    setTitularPrograma(c);
    setProgSel(null);
    setProgEmail("");
    setProgNumero("");
    setProgNumeroPrograma("");
    setProgBusca(null);
    setModalPrograma(true);
  };

  const handleCadastrarPrograma = async () => {
    if (!progSel)           { message.error("Selecione um programa."); return; }
    if (!progNumero.trim()) { message.error("Informe o número/CPF do programa."); return; }
    setSavingProg(true);
    const cliId = titularPrograma?.cli_id ?? titularPrograma?.CLI_ID ?? clienteId;
    try {
      await api.post("/ServerPrincipal/InserirProgramas", {
        Nome:      progSel.nome,
        Email:     progEmail || "",
        Telefone:  progNumero || "",
        IDCliente: String(cliId),
        NumeroPrograma: progNumeroPrograma || "",
      });
      message.success("Programa cadastrado com sucesso!");
      setModalPrograma(false);
      carregarDados(clienteId);
    } catch (e) {
      message.error(getErroMsg(e, "Erro ao cadastrar programa."));
    } finally {
      setSavingProg(false);
    }
  };

  const tv = (t, key, fb = "") => t?.[key] ?? t?.[key?.toUpperCase()] ?? fb;

  // ── Salvar novo titular ──────────────────────────────────────────────
  const handleCadastrar = async () => {
    if (!novoForm.nome.trim()) { message.error("Nome é obrigatório."); return; }
    if (!novoForm.cpf.trim())  { message.error("CPF é obrigatório.");  return; }
    setSaving(true);
    try {
      await api.post("/ServerPrincipal/InserirClientes", {
        Login:     String(loginId || clienteId || 0),
        Nome:      novoForm.nome,
        CPF:       novoForm.cpf.replace(/\D/g, ""),
        Email:     novoForm.email || "",
        Telefone:  novoForm.celular.replace(/\D/g, "") || "",
        IDCliente: String(clienteId || 0),
      });
      message.success("Titular cadastrado com sucesso!");
      setModalNovo(false);
      setNovoForm({ nome: "", apelido: "", cpf: "", email: "", celular: "", comissao: "", banco: "", agencia: "", conta: "", pix: "" });
      carregarDados(clienteId);
    } catch (e) {
      message.error(getErroMsg(e, "Erro ao cadastrar."));
    } finally {
      setSaving(false);
    }
  };

  const setNovo = (key, val) => setNovoForm((p) => ({ ...p, [key]: val }));

  // ── Render ──────────────────────────────────────────────────────────
  return (
    <div style={{ minHeight: "100vh", background: "#f0f2f5", padding: "24px" }}>
      <div style={{ background: "#fff", borderRadius: 8, boxShadow: "0 1px 4px rgba(0,0,0,0.08)" }}>

        {/* Header */}
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "16px 20px", borderBottom: "1px solid #f0f0f0" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <TeamOutlined style={{ fontSize: 16, color: "#555" }} />
            <span style={{ fontSize: 15, fontWeight: 700, color: "#222" }}>Titulares de Conta</span>
          </div>
          <button
            onClick={() => { setNovoForm({ nome:"",apelido:"",cpf:"",email:"",celular:"",comissao:"",banco:"",agencia:"",conta:"",pix:"" }); setNovoTipo("percentual"); setModalNovo(true); }}
            style={{ background: "#1e3a4a", color: "#fff", border: "none", borderRadius: 6, padding: "8px 18px", fontSize: 12, fontWeight: 700, letterSpacing: "0.08em", cursor: "pointer" }}
          >
            NOVO TITULAR
          </button>
        </div>

        <Spin spinning={loading}>
          <div style={{ padding: "16px 20px" }}>

            {/* Busca */}
            <div style={{ display: "flex", alignItems: "center", gap: 10, background: "#eef1f5", borderRadius: 6, padding: "8px 14px", marginBottom: 16 }}>
              <FilterOutlined style={{ color: "#aaa", fontSize: 15 }} />
              <input value={busca} onChange={(e) => setBusca(e.target.value)}
                style={{ border: "none", background: "transparent", outline: "none", fontSize: 14, color: "#333", width: "100%" }}
              />
            </div>

            {/* Lista */}
            <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
              {clientesFiltrados.length === 0 && !loading && (
                <div style={{ textAlign: "center", color: "#bbb", padding: "32px 0", fontSize: 13 }}>Nenhum titular encontrado.</div>
              )}

              {clientesFiltrados.map((c) => {
                const cliId    = c.cli_id    ?? c.CLI_ID ?? c.CLI_IDTITULAR;
                const nome     = c.cli_nome  ?? c.CLI_NOME  ?? "—";
                const cpf      = c.cli_cpf   ?? c.CLI_CPF   ?? c.tit_cpf ?? c.TIT_CPF ?? "";
                const progs    = programasPorCliente(cliId);
                const visiveis = progs.slice(0, 5);
                const extras   = progs.length - 5;

                return (
                  <div key={cliId} style={{ background: "#fff", borderRadius: 8, border: "1px solid #ebebeb", padding: "14px 16px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                    <div style={{ flex: 1 }}>
                      <div style={{ fontWeight: 700, fontSize: 14, color: "#222", marginBottom: 2 }}>{nome}</div>
                      <div style={{ fontSize: 12, color: "#888", marginBottom: 12 }}>{mascaraCPF(cpf)}</div>
                      <div style={{ display: "flex", alignItems: "center", gap: 6, flexWrap: "wrap" }}>
                        {visiveis.map((p) => {
                          const np = p.car_nome_programa ?? p.CAR_NOME_PROGRAMA ?? "";
                          return <ProgramaBolinha key={p.car_id ?? np} nome={np} size={40} />;
                        })}
                        {extras > 0 && (
                          <span style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", width: 40, height: 40, borderRadius: "50%", border: "2px dashed #f0a000", color: "#f0a000", fontSize: 12, fontWeight: 700 }}>
                            +{extras}
                          </span>
                        )}
                        {progs.length === 0 && <span style={{ fontSize: 12, color: "#ccc" }}>Sem programas</span>}
                      </div>
                    </div>

                    <div style={{ display: "flex", alignItems: "center", gap: 12, marginLeft: 16 }}>
                      <Dropdown
                        menu={{
                          items: [
                            { key: "detalhe", icon: <EyeOutlined />,    label: "Detalhes", onClick: () => abrirDetalhe(c) },
                            { key: "editar",  icon: <EditOutlined />,   label: "Editar",  onClick: () => abrirEditar(c)  },
                            { key: "excluir", icon: <DeleteOutlined />, label: "Excluir", danger: true, onClick: () => abrirExcluir(c) },
                          ],
                        }}
                        trigger={["click"]}
                        placement="bottomRight"
                      >
                        <button style={{ background: "none", border: "none", cursor: "pointer", color: "#aaa", fontSize: 18, padding: "4px 6px", borderRadius: 4 }}>
                          <MoreOutlined />
                        </button>
                      </Dropdown>

                      <button
                        onClick={() => abrirModalPrograma(c)}
                        style={{ width: 36, height: 36, borderRadius: "50%", border: "1.5px solid #ccc", background: "#fff", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", color: "#aaa", fontSize: 16 }}>
                        <PlusOutlined />
                      </button>
                    </div>
                  </div>
                );
              })}
            </div>

            {clientesFiltrados.length > 0 && (
              <div style={{ textAlign: "right", fontSize: 12, color: "#aaa", marginTop: 14 }}>
                {clientesFiltrados.length} {clientesFiltrados.length === 1 ? "titular." : "titulares."}
              </div>
            )}
          </div>
        </Spin>
      </div>

      {/* ══ Modal NOVO TITULAR ══ */}
      <Modal open={modalNovo} onCancel={() => setModalNovo(false)} footer={null} width={420} destroyOnHidden closable={false} styles={{ body: { padding: "16px 16px 0" } }}>
        <ModalLayout
          title="Preencha as informações sobre o novo titular."
          onCancel={() => setModalNovo(false)}
          onConfirm={handleCadastrar}
          confirmLabel="CADASTRAR"
          saving={saving}
        >
          <FieldInput label="Nome" value={novoForm.nome} onChange={(v) => setNovo("nome", v)} placeholder="Ex. Fulano de Tal" />

          <div style={{ display: "flex", gap: 12 }}>
            <FieldInput label="Apelido" value={novoForm.apelido} onChange={(v) => setNovo("apelido", v)} placeholder="Ex. Fulano" half />
            <FieldInput label="CPF:" value={novoForm.cpf}
              onChange={(v) => setNovo("cpf", mascaraCPF(v))}
              placeholder="XXX.XXX.XXX-XX"
              suffix={<NumberOutlined style={{ fontSize: 12 }} />}
              half
            />
          </div>

          <div style={{ display: "flex", gap: 12 }}>
            <FieldInput label="Email" value={novoForm.email} onChange={(v) => setNovo("email", v)} placeholder="Ex. fulano@example.org" suffix={<MailOutlined style={{ fontSize: 12 }} />} half />
            <FieldInput label="Celular" value={novoForm.celular}
              onChange={(v) => setNovo("celular", mascaraTelefone(v))}
              placeholder="(XX) XXXXX-XXXXX"
              suffix={<PhoneOutlined style={{ fontSize: 12 }} />}
              half
            />
          </div>

          <SecaoComissao valor={novoForm.comissao} onChange={(v) => setNovo("comissao", v)} tipo={novoTipo} onTipo={setNovoTipo} />

          <SecaoBancaria banco={novoForm.banco} agencia={novoForm.agencia} conta={novoForm.conta} pix={novoForm.pix}
            onChange={(k, v) => setNovo(k, v)}
          />
        </ModalLayout>
      </Modal>

      {/* ══ Modal DETALHE ══ */}
      <Modal open={modalDetalhe} onCancel={() => setModalDetalhe(false)} footer={null} width={420} destroyOnHidden closable={true} styles={{ body: { padding: "16px 16px 0" } }}>
        {titularSel && (
          <ModalLayout
            title="Confirma as informações do titular abaixo."
            onCancel={() => setModalDetalhe(false)}
            onConfirm={() => setModalDetalhe(false)}
            confirmLabel="SALVAR"
          >
            <FieldInput label="Nome" value={tv(titularSel,"cli_nome")} readOnly />

            <div style={{ display: "flex", gap: 12 }}>
              <FieldInput label="Apelido"
                value={tv(titularSel,"cli_nome","").split(" ")[0]}
                readOnly half
              />
              <FieldInput label="CPF:"
                value={mascaraCPF(tv(titularSel,"cli_cpf"))}
                suffix={<NumberOutlined style={{ fontSize: 12 }} />}
                readOnly half
              />
            </div>

            <div style={{ display: "flex", gap: 12 }}>
              <FieldInput label="Email"
                value={tv(titularSel,"cli_email")}
                suffix={<MailOutlined style={{ fontSize: 12 }} />}
                readOnly half
              />
              <FieldInput label="Celular"
                value={mascaraTelefone(tv(titularSel,"cli_telefone"))}
                suffix={<PhoneOutlined style={{ fontSize: 12 }} />}
                readOnly half
              />
            </div>

            <SecaoComissao
              valor={tv(titularSel,"tit_comissao","0")}
              tipo={detTipo} onTipo={setDetTipo}
              readOnly
            />

            <SecaoBancaria
              banco={tv(titularSel,"tit_banco")}
              agencia={tv(titularSel,"tit_agencia")}
              conta={tv(titularSel,"tit_conta")}
              pix={tv(titularSel,"tit_pix")}
              readOnly
            />
          </ModalLayout>
        )}
      </Modal>

      {/* ══ Modal NOVO PROGRAMA ══ */}
      <Modal
        open={modalPrograma}
        onCancel={() => setModalPrograma(false)}
        footer={null}
        width={520}
        destroyOnHidden
        closable={true}
        styles={{ body: { padding: "20px" } }}
      >
        {titularPrograma && (() => {
          const nome  = titularPrograma.cli_nome  ?? titularPrograma.CLI_NOME  ?? "—";
          const cpf   = String(titularPrograma.cli_cpf   ?? titularPrograma.CLI_CPF   ?? titularPrograma.tit_cpf ?? "");
          const email = titularPrograma.cli_email ?? titularPrograma.CLI_EMAIL ?? "";
          const temProgSel = !!progSel;

          const progsFiltrados = PROGRAMAS_LISTA.filter((p) =>
            !progBusca || p.nome.toLowerCase().includes(progBusca.toLowerCase())
          );

          return (
            <div>
              <div style={{ fontSize: 13, fontWeight: 600, color: "#333", marginBottom: 16 }}>
                Preencha as informações sobre a nova conta.
              </div>

              {/* Card titular */}
              <div style={{ background: "#f7f9fc", borderRadius: 8, border: "1px solid #e4e8ef", padding: "16px", marginBottom: 0 }}>
                <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", marginBottom: 16 }}>
                  <div>
                    <div style={{ fontSize: 11, color: "#888", marginBottom: 4 }}>Titular</div>
                    <div style={{ fontSize: 15, fontWeight: 700, color: "#222" }}>
                      {titularPrograma?.cli_nome ?? titularPrograma?.CLI_NOME ?? nome}
                    </div>
                    <div style={{ fontSize: 12, color: "#888", marginTop: 2 }}>
                      {String(titularPrograma?.cli_cpf ?? titularPrograma?.CLI_CPF ?? cpf).replace(/\D/g,"")}
                    </div>
                  </div>
                  {temProgSel
                    ? <span style={{
                        display: "inline-flex", alignItems: "center", justifyContent: "center",
                        width: 48, height: 48, borderRadius: "50%",
                        background: progSel.bg, color: "#fff", fontSize: 13, fontWeight: 700,
                        boxShadow: "0 2px 8px rgba(0,0,0,0.18)",
                      }}>{progSel.letra}</span>
                    : <span style={{
                        width: 48, height: 48, borderRadius: "50%",
                        border: "1.5px dashed #ccc",
                        display: "inline-flex", alignItems: "center", justifyContent: "center",
                        fontSize: 10, color: "#bbb",
                      }}>LOGO</span>
                  }
                </div>

                {/* Titular select + Programa select */}
                <div style={{ display: "flex", gap: 12, marginBottom: 12 }}>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontSize: 11, color: "#888", marginBottom: 4 }}>Titular</div>
                    <select
                      value={String(titularPrograma?.cli_id ?? titularPrograma?.CLI_ID ?? "")}
                      onChange={(e) => {
                        const sel = clientes.find((c) => String(c.cli_id ?? c.CLI_ID) === e.target.value);
                        if (sel) {
                          setTitularPrograma(sel);
                          setProgEmail(sel.cli_email ?? sel.CLI_EMAIL ?? "");
                          setProgNumero(sel.cli_cpf   ?? sel.CLI_CPF  ?? "");
                        }
                      }}
                      style={{
                        width: "100%", height: 38, borderRadius: 6,
                        border: "1px solid #dde1e9", background: "#fff",
                        fontSize: 13, color: "#333",
                        padding: "0 10px", outline: "none", cursor: "pointer",
                      }}
                    >
                      {clientes.map((c) => {
                        const cliId   = c.cli_id  ?? c.CLI_ID  ?? "";
                        const cliNome = c.cli_nome ?? c.CLI_NOME ?? "—";
                        return (
                          <option key={String(cliId)} value={String(cliId)}>
                            {cliNome} ({cliNome.split(" ")[0]})
                          </option>
                        );
                      })}
                    </select>
                  </div>

                  <div style={{ flex: 1, position: "relative" }}>
                    <div style={{ fontSize: 11, color: "#888", marginBottom: 4 }}>Programa:</div>
                    <div
                      style={{ display: "flex", alignItems: "center", background: "#fff", border: "1px solid #dde1e9", borderRadius: 6, padding: "0 10px", height: 38, fontSize: 13, color: "#333", cursor: "pointer", userSelect: "none" }}
                      onClick={() => setProgBusca(progBusca === null ? "" : null)}
                    >
                      {progSel
                        ? <><LogoProgramaCircle prog={progSel} size={22} /><span style={{ marginLeft: 8 }}>{progSel.nome}</span></>
                        : <span style={{ color: "#bbb" }}>Selecione...</span>
                      }
                      <span style={{ marginLeft: "auto", color: "#bbb", fontSize: 11 }}>{progBusca === null ? "▴" : "▾"}</span>
                    </div>
                    {progBusca !== null && (
                      <div style={{ position: "absolute", top: 62, left: 0, right: 0, zIndex: 200, background: "#fff", borderRadius: 6, boxShadow: "0 4px 20px rgba(0,0,0,0.15)", border: "1px solid #dde1e9", maxHeight: 220, overflow: "hidden", display: "flex", flexDirection: "column" }}>
                        <div style={{ padding: "8px 10px", borderBottom: "1px solid #f0f0f0" }}>
                          <input
                            autoFocus
                            value={progBusca || ""}
                            onChange={(e) => setProgBusca(e.target.value)}
                            placeholder="Buscar programa..."
                            style={{ width: "100%", border: "none", outline: "none", fontSize: 13, background: "transparent" }}
                          />
                        </div>
                        <div style={{ overflowY: "auto", flex: 1 }}>
                          {progsFiltrados.map((p) => (
                            <div
                              key={p.nome}
                              onClick={() => { setProgSel(p); setProgBusca(null); }}
                              style={{
                                display: "flex", alignItems: "center", gap: 10,
                                padding: "10px 14px", cursor: "pointer", fontSize: 13,
                                background: progSel?.nome === p.nome ? "#1e3a4a" : "#fff",
                                color: progSel?.nome === p.nome ? "#fff" : "#333",
                              }}
                              onMouseEnter={(e) => { if (progSel?.nome !== p.nome) e.currentTarget.style.background = "#f5f5f5"; }}
                              onMouseLeave={(e) => { if (progSel?.nome !== p.nome) e.currentTarget.style.background = "#fff"; }}
                            >
                              <LogoProgramaCircle prog={p} size={30} />
                              <span>{p.nome}</span>
                            </div>
                          ))}
                          {progsFiltrados.length === 0 && (
                            <div style={{ padding: "12px 14px", color: "#bbb", fontSize: 13 }}>Nenhum programa encontrado</div>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                {/* Email + Número */}
                <div style={{ display: "flex", gap: 12 }}>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontSize: 11, color: "#888", marginBottom: 4 }}>Email no programa:</div>
                    <div style={{ display: "flex", alignItems: "center", background: "#fff", border: "1px solid #dde1e9", borderRadius: 6, padding: "0 10px", height: 38 }}>
                      <input
                        value={progEmail}
                        onChange={(e) => setProgEmail(e.target.value)}
                        placeholder={email || "email@exemplo.com"}
                        style={{ flex: 1, border: "none", outline: "none", fontSize: 13, background: "transparent", color: "#333" }}
                      />
                      <MailOutlined style={{ color: "#bbb", fontSize: 13 }} />
                    </div>
                  </div>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontSize: 11, color: "#888", marginBottom: 4 }}>Número:</div>
                    <div style={{ display: "flex", alignItems: "center", background: "#fff", border: "1px solid #dde1e9", borderRadius: 6, padding: "0 10px", height: 38 }}>
                      <input
                        value={progNumero}
                        onChange={(e) => setProgNumero(e.target.value)}
                        placeholder="Número do programa"
                        style={{ flex: 1, border: "none", outline: "none", fontSize: 13, background: "transparent", color: "#333" }}
                      />
                    </div>
                  </div>
                </div>

                {/* Número Programa (ID) - NOVO CAMPO */}
                <div style={{ display: "flex", gap: 12, marginTop: 12 }}>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontSize: 11, color: "#888", marginBottom: 4 }}>Número Programa (ID):</div>
                    <div style={{ display: "flex", alignItems: "center", background: "#fff", border: "1px solid #dde1e9", borderRadius: 6, padding: "0 10px", height: 38 }}>
                      <input
                        value={progNumeroPrograma}
                        onChange={(e) => setProgNumeroPrograma(e.target.value)}
                        placeholder="Número do programa (ID)"
                        style={{ flex: 1, border: "none", outline: "none", fontSize: 13, background: "transparent", color: "#333" }}
                      />
                    </div>
                  </div>
                </div>
              </div>

              {/* Botões */}
              <div style={{ display: "flex", justifyContent: "flex-end", gap: 8, marginTop: 20 }}>
                <button onClick={() => setModalPrograma(false)}
                  style={{ padding: "8px 22px", borderRadius: 4, border: "1px solid #d9d9d9", background: "#fff", cursor: "pointer", fontSize: 12, fontWeight: 700, letterSpacing: "0.06em", color: "#555" }}>
                  CANCELAR
                </button>
                <button onClick={handleCadastrarPrograma} disabled={savingProg}
                  style={{ padding: "8px 22px", borderRadius: 4, border: "none", background: savingProg ? "#bfbfbf" : "#1e3a4a", cursor: savingProg ? "not-allowed" : "pointer", fontSize: 12, fontWeight: 700, letterSpacing: "0.06em", color: "#fff" }}>
                  {savingProg ? "SALVANDO..." : "CADASTRAR"}
                </button>
              </div>
            </div>
          );
        })()}
      </Modal>

      {/* ══ Modal EDITAR TITULAR ══ */}
      <Modal open={modalEditar} onCancel={() => setModalEditar(false)} footer={null} width={420}
        destroyOnHidden closable={false} styles={{ body: { padding: "16px 16px 0" } }}>
        <ModalLayout
          title="Editar informações do titular."
          onCancel={() => setModalEditar(false)}
          onConfirm={handleAtualizarTitular}
          confirmLabel="SALVAR"
          saving={salvandoEdit}
        >
          <FieldInput label="Nome" value={editForm.nome}
            onChange={(v) => setEdit("nome", v)} placeholder="Nome completo" />

          <div style={{ display: "flex", gap: 12 }}>
            <FieldInput label="CPF:" value={editForm.cpf}
              onChange={(v) => setEdit("cpf", mascaraCPF(v))}
              placeholder="XXX.XXX.XXX-XX"
              suffix={<NumberOutlined style={{ fontSize: 12 }} />} half />
            <FieldInput label="Celular" value={editForm.celular}
              onChange={(v) => setEdit("celular", mascaraTelefone(v))}
              placeholder="(XX) XXXXX-XXXXX"
              suffix={<PhoneOutlined style={{ fontSize: 12 }} />} half />
          </div>

          <FieldInput label="Email" value={editForm.email}
            onChange={(v) => setEdit("email", v)}
            placeholder="email@exemplo.com"
            suffix={<MailOutlined style={{ fontSize: 12 }} />} />
        </ModalLayout>
      </Modal>

      {/* ══ Modal EXCLUIR TITULAR ══ */}
      <Modal open={modalExcluir} onCancel={() => setModalExcluir(false)} footer={null} width={400}
        destroyOnHidden closable styles={{ body: { padding: "24px" } }}>
        <div style={{ textAlign: "center" }}>
          <div style={{ fontSize: 40, marginBottom: 12 }}>🗑️</div>
          <div style={{ fontSize: 15, fontWeight: 700, color: "#222", marginBottom: 8 }}>
            Excluir Titular
          </div>
          <div style={{ fontSize: 13, color: "#666", marginBottom: 6, lineHeight: 1.6 }}>
            Tem certeza que deseja excluir o titular
          </div>
          <div style={{ fontSize: 14, fontWeight: 700, color: "#333", marginBottom: 6 }}>
            {titularExcluindo?.cli_nome ?? titularExcluindo?.CLI_NOME ?? ""}?
          </div>
          <div style={{ fontSize: 12, color: "#888", marginBottom: 6 }}>
            {mascaraCPF(titularExcluindo?.cli_cpf ?? titularExcluindo?.CLI_CPF ?? "")}
          </div>
          <div style={{ fontSize: 12, color: "#e00", marginBottom: 24 }}>
            Esta ação não pode ser desfeita.
          </div>
          <div style={{ display: "flex", justifyContent: "center", gap: 12 }}>
            <button onClick={() => setModalExcluir(false)}
              style={{ padding: "8px 24px", borderRadius: 4, border: "1px solid #d9d9d9", background: "#fff", cursor: "pointer", fontSize: 12, fontWeight: 700, color: "#555" }}>
              NÃO
            </button>
            <button onClick={handleExcluirTitular} disabled={excluindo}
              style={{ padding: "8px 24px", borderRadius: 4, border: "none", background: excluindo ? "#bfbfbf" : "#e00", color: "#fff", cursor: excluindo ? "not-allowed" : "pointer", fontSize: 12, fontWeight: 700 }}>
              {excluindo ? "EXCLUINDO..." : "SIM, EXCLUIR"}
            </button>
          </div>
        </div>
      </Modal>

    </div>
  );
}